import React from "react";
import deleteImage from "../assets/del.svg";
import editImage from "../assets/edit.svg";
import { useDispatch, useSelector } from "react-redux";
import { removeTransaction } from "../RTK/Features/Transaction/TrnasactionSlice";
import { setItemToEdit } from "../RTK/Features/TransactionEdit/TransactionEditSlice";
import { useNavigate, useMatch } from "react-router-dom";
import { applyAllfilter } from "../RTK/Features/filter/filterSlice";

function Transaction({ transaction, allTransactions }) {
  const dispatch = useDispatch();
  let match = useMatch("/alltransactions");
  let navigate = useNavigate();

  const { searchTerm, transactionType, order, limit } = useSelector(
    (state) => state.filter
  );

  const handleDelete = (id) => {
    applyAllfilter(
      dispatch(applyAllfilter({ searchTerm, transactionType, order, limit }))
    );
    dispatch(removeTransaction(id));
  };

  const handleEdit = (data) => {
    dispatch(setItemToEdit(data));
    if (match) {
      navigate("/");
    }
  };
  const bgColor =
    transaction.type === "income"
      ? "bg-sky-700	hover:bg-sky-800 active:bg-sky-900"
      : "bg-red-500 hover:bg-red-600 active:bg-red-700";
  const forAllTrtansactions = allTransactions ? "w-[450px]" : "w-[400px]";
  return (
    <>
      <div
        className={`flex items-center justify-between ${forAllTrtansactions} p-2 ${bgColor}`}
      >
        <div className="text-slate-300">{transaction.name}</div>
        <div className="flex items-center justify-center text-slate-300">
          <div className="px-2 font-bold">{transaction.amount}</div>
          <div className="px-2">
            <img
              className="w-4 h-4"
              src={deleteImage}
              alt="Delete"
              onClick={() => handleDelete(transaction.id)}
            />
          </div>
          <div className="px-2">
            <img
              className="w-4 h-4"
              src={editImage}
              alt="Edit"
              onClick={() => handleEdit(transaction)}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default Transaction;
